import { useRef, useState } from 'react';
import { FormValueType } from '../../hooks/useFormValues';
import { Mutation, useImageUpload } from '../../hooks/useImageUpload';
import { IconButton } from '../IconButton';
import { IconSpinner, IconUpload } from '../QuirkIcons';

export const ImageUploadInput = <ArgType, ResultType>({
	fieldName,
	document,
	addImage,
	setValues,
	label
}: {
	fieldName: keyof ResultType;
	document?: ResultType;
	addImage: Mutation<ArgType, ResultType>;
	setValues: (value: FormValueType<ResultType>) => void;
	label: string;
}) => {
	const [state, setState] = useState<string>('');
	const { uploadImage, loading } = useImageUpload(document, addImage);
	const inputFile = useRef<HTMLInputElement>(null);

	const onUploadClick = () => {
		inputFile.current?.click();
	};

	const onImageInputChange = async (e: any) => {
		setState(e.target.value);
		await uploadImage(e);
		setValues({ [fieldName as string]: document?.[fieldName] } as FormValueType<ResultType>);
		setState('');
	};

	return (
		<>
			<IconButton
				label={label}
				icon={loading ? <IconSpinner size={20} flex /> : <IconUpload />}
				onClick={onUploadClick}
				disabled={loading}
				iconRight
				outline
			/>
			<input
				type="file"
				name={fieldName as string}
				ref={inputFile}
				style={{ visibility: 'hidden', height: '0px', width: '0px' }}
				onChange={onImageInputChange}
				value={state}
			/>
		</>
	);
};
